import { useState } from "react";
import { Tooltip, IconButton, Switch } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSelector, useDispatch } from "react-redux";
import { obtenerMensualidadesBanco, eliminarMensualidadBanco, obtenerMensualidadBanco} from "../../../ducks/bancoDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
import { ToastMessage } from "../../../global/ToastMessage";
import { yellow } from "@material-ui/core/colors";
const columns = [
    { id: "Mensualidad", minWidth: 150, align: "center", label: "Mensualidad" },
    { id: "SobreTasa", minWidth: 30, align: "center", label: "Sobretasa" },
    { id: "Accion", minWidth: 30, align: "center", label: "" },
];

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    container: {
        maxHeight: 440,
    },
});

const TMensualidad = () => {
    const classes = useStyles()
    const { listaMensualidadesBanco, banco } = useSelector(store => store.banco)
    const dispatch = useDispatch()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const handleEdit = ({ bancoMensualidad }) => {
        dispatch(obtenerMensualidadBanco({ mensualidadBanco: bancoMensualidad, editar: true }))
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    const handleEliminar = ({ bancoMensualidad }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(eliminarMensualidadBanco({ IdBancoMensualidad: bancoMensualidad.IdBancoMensualidad })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "error",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerMensualidadesBanco({IdBanco: banco.IdBanco}))
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listaMensualidadesBanco
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.IdBancoMensualidad}>
                                        <TableCell align="center">{`${row.Mensualidad?.Cantidad} Meses`}</TableCell>
                                        <TableCell align="center">
                                            {`${row.SobreTasa} %`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Tooltip title="Edutar">
                                                <IconButton
                                                    aria-label="Edutar"
                                                    onClick={() => { handleEdit({ bancoMensualidad: row }) }}
                                                >
                                                    <EditIcon style={{ color: yellow[400] }} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Eliminar">
                                                <IconButton
                                                    aria-label="Eliminar"
                                                    onClick={() => { handleEliminar({ bancoMensualidad: row }) }}
                                                >
                                                    <DeleteIcon color="error" />
                                                </IconButton>
                                            </Tooltip>

                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={listaMensualidadesBanco.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />

        </Paper>
    );
};
export default TMensualidad;
